import { IonButton, IonContent, IonPage } from '@ionic/react';

import { Capacitor } from '@capacitor/core';

import logo from '@/assets/images/logo/logo-with-icon.png';
import { ButtonContainer, Padding, Promo } from '@/components/common';
import { Text } from '@/components/memo';
import { useToast } from '@/hooks';
import { APP_STORE_ID, PLATFORMS } from '@/utils/constants';
import { AppUpdate } from '@capawesome/capacitor-app-update';

import './Update.css';

const Update: React.FC = () => {
  const displayToast = useToast();

  const openAppStore = async () => {
    try {
      if (Capacitor.getPlatform() === PLATFORMS.IOS) {
        await AppUpdate.openAppStore({ appId: APP_STORE_ID });
      } else {
        await AppUpdate.openAppStore();
      }
    } catch {
      displayToast({
        message: `There was an error opening the App Store, please update manually.`,
        duration: 5000,
        position: 'bottom'
      });
    }
  };

  const copy = {
    promo: {
      header: (
        <>
          Time for an <Text color="primary">update!</Text>
        </>
      ),
      subHeader:
        'You need to update your version of the Odonto App to continue.'
    },
    updateButtonText: "Let's go"
  };

  return (
    <IonPage id="update">
      <IonContent scrollX={false} scrollY={false}>
        <Padding>
          <div className="update__promo-container">
            <Promo
              image={logo}
              imageStyle={{ maxWidth: 192 }}
              header={copy.promo.header}
              subHeader={copy.promo.subHeader}
            />
          </div>
          <ButtonContainer>
            <IonButton
              id="update-button"
              onClick={openAppStore}
              expand="block"
              fill="solid"
              size="default"
              color="primary"
              strong={true}
            >
              {copy.updateButtonText}
            </IonButton>
          </ButtonContainer>
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Update;
